'use strict';
var __assign =
	(this && this.__assign) ||
	function () {
		__assign =
			Object.assign ||
			function (t) {
				for (var s, i = 1, n = arguments.length; i < n; i++) {
					s = arguments[i];
					for (var p in s)
						if (Object.prototype.hasOwnProperty.call(s, p))
							t[p] = s[p];
				}
				return t;
			};
		return __assign.apply(this, arguments);
	};
var __rest =
	(this && this.__rest) ||
	function (s, e) {
		var t = {};
		for (var p in s)
			if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
				t[p] = s[p];
		if (s != null && typeof Object.getOwnPropertySymbols === 'function')
			for (
				var i = 0, p = Object.getOwnPropertySymbols(s);
				i < p.length;
				i++
			)
				if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
		return t;
	};
Object.defineProperty(exports, '__esModule', { value: true });
var classnames = require('classnames');
var React = require('react');
var prop_types_1 = require('../../types/prop.types');
var Badge = function (_a) {
	var className = _a.className,
		color = _a.color,
		isPill = _a.isPill,
		label = _a.label,
		restProps = __rest(_a, ['className', 'color', 'isPill', 'label']);
	var _b;
	return React.createElement(
		'span',
		__assign(
			{
				'aria-hidden': true,
				className: classnames(
					className,
					'badge',
					((_b = {
						'badge-pill': isPill,
					}),
					(_b['badge-' + color] = color != null),
					_b)
				),
			},
			restProps
		),
		label
	);
};
exports.Badge = Badge;
Badge.Color = prop_types_1.ThemeColor;
Badge.defaultProps = {
	color: Badge.Color.Secondary,
};
//# sourceMappingURL=Badge.js.map
